import { Schedule, ScheduleUpdatePayload } from "../../types/Schedule";
import { APICore } from "./apiCore";

const api = new APICore();
const baseUrl = "/schedules";

export const updateScheduleApi=async(params: any) =>{

   return api.update(`${baseUrl}`, params.data);
}

export const getSchedulesApi = async (id : number): Promise<Schedule> => {
  try {
    const response = await api.get(`${baseUrl}/user/${id}`,"");
    return response.data;
  } catch (error: any) {
    throw error.response ? error.response.data : new Error('Error de conexión');
  }
}

